import { useState } from 'react';
import { Modal, Button } from '@components/ui';

export default function BlokModal({ isOpen, onClose, onSubmit, block = null }) {
    const isEdit = !!block;
    const [formData, setFormData] = useState({
        name: block?.name || '',
        totalFloors: block?.totalFloors || '',
        apartmentsPerFloor: block?.apartmentsPerFloor || '',
    });

    const handleSubmit = () => {
        onSubmit?.(formData);
        onClose();
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={isEdit ? '🏢 Blok Düzenle' : '🏢 Yeni Blok Ekle'}
            size="sm"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose}>İptal</Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        {isEdit ? 'Güncelle' : 'Kaydet'}
                    </Button>
                </>
            }
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Blok Adı *</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                        placeholder="A Blok"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                    />
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Kat Sayısı</label>
                        <input
                            type="number"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            value={formData.totalFloors}
                            onChange={(e) => handleChange('totalFloors', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Kat Başı Daire</label>
                        <input
                            type="number"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary"
                            value={formData.apartmentsPerFloor}
                            onChange={(e) => handleChange('apartmentsPerFloor', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
